import { useContext, createContext } from 'react';

import { LanguageContent } from './';

const ContentContext = createContext<LanguageContent | undefined>(undefined);

export const useContent = (): LanguageContent => {
    const context = useContext(ContentContext);

    if (context === undefined) {
        throw new Error('useContentContext must be used within a ContentContext');
    }

    return context;
};

export default ContentContext.Provider;
